
export const moduleRoutes = {
    list: 'users/',
    status: 'users/status/',
};
